import Axios from "axios";
import token from "./setToken";

export default {
  async search(searchCondition) {
    let params = new URLSearchParams();
    params.append('searchCondition', JSON.stringify(searchCondition));

    try {
      const res = await Axios.post("/api/MstorageOccupancyRateList", params, token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("庫腹占有率計算マスタ一覧を取得できません[search]");
      throw error;
    }
  },

  async getData(id) {
    try {
      const res = await Axios.get("/api/MstorageOccupancyRate/" + id, token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("庫腹占有率計算マスタデータを取得できません[getDataList]");
      throw error;
    }
  },

  async setMstorageOccupancyRateData(masterData, mode) {
    let params = new URLSearchParams();
    params.append('masterData', JSON.stringify(masterData));
    params.append('mode', mode);

    try {
      const res = await Axios.post('/api/MstorageOccupancyRate', params, token.setTokenToHeader());
      return res;

    } catch (error) {
      console.error("庫腹占有率計算マスタデータを設定できません");
      throw error;
    }
  },

  async delMstorageOccupancyRateData(city_code) {
    try {
      const res = await Axios.delete('/api/MstorageOccupancyRate/' + city_code, token.setTokenToHeader());
      return res;

    } catch (error) {
      console.error("庫腹占有率計算マスタデータを削除できません");
      throw error;
    }
  },

};
